interface Props {
  title: string; // usar "string" en minúscula
}

export const SignHeader = (props: Props): React.ReactNode => {
  return (
    <div className="w-full space-y-4 mb-4">
      <div className="flex flex-col items-center justify-center w-full gap-7">
        <div className="relative w-full max-w-[320px] aspect-[320/100]">
          <img
            alt="ROSC"
            className="w-full h-auto absolute inset-0"
            src="/images/logos/logo-full.svg"
          />
        </div>
      </div>
      <div className="text-[2rem] font-bold text-primary-dark dark:text-foreground text-center">
        {props.title}
      </div>
    </div>
  );
};
